(function () {

  if (window.RUCartUpsellAntislipLoaded) return;
  window.RUCartUpsellAntislipLoaded = true;

function updateUpsellPrice(panel, sizeButton) {

  if (!panel || !sizeButton) return;

  const card = panel.closest('.mf-inline-upsell');
  if (!card) return;

  const price = card.querySelector('.mf-upsell-main-price');
  const comparePrice = card.querySelector('.mf-upsell-main-compare-price');
  const compareBreak = card.querySelector('.mf-upsell-main-compare-break');

  if (price) {
    price.textContent = sizeButton.dataset.price;
  }

  const compareValue = sizeButton.dataset.comparePrice;

  if (compareValue) {

    if (comparePrice) {
      comparePrice.textContent = compareValue;
      comparePrice.hidden = false;
    }

    if (compareBreak) {
      compareBreak.hidden = false;
    }

  } else {

    if (comparePrice) {
      comparePrice.textContent = '';
      comparePrice.hidden = true;
    }

    if (compareBreak) {
      compareBreak.hidden = true;
    }

  }
}


  /*
   * Klickhantering
   */
  document.addEventListener('click', function (event) {


    /* =========================================
       ÖPPNA / STÄNG STORLEKSVAL
    ========================================= */

    const toggle = event.target.closest('.mf-upsell-toggle');

    if (toggle) {

      event.preventDefault();
      event.stopPropagation();

      const card = toggle.closest('.mf-inline-upsell');
      if (!card) return;

      const panel = card.querySelector('.mf-upsell-inline');
      if (!panel) return;

      const isClosed = panel.hasAttribute('hidden');

if (isClosed) {

  panel.removeAttribute('hidden');

  toggle.textContent = 'Stäng';
  toggle.setAttribute('aria-expanded', 'true');

  const selectedSize = panel.querySelector(
    '.mf-upsell-size.is-selected, .mf-upsell-size.selected'
  );

  if (selectedSize) {
    updateUpsellPrice(panel, selectedSize);
  }

  /*
   * Scrolla mjukt längst ner i cart drawern
   * efter att storleksväljaren har öppnats.
   */
  const scrollArea = card.closest('.flex-top');

  if (scrollArea) {

    requestAnimationFrame(function () {

      requestAnimationFrame(function () {

        scrollArea.scrollTo({
          top: scrollArea.scrollHeight,
          behavior: 'smooth'
        });

      });

    });

  }

} else {

  panel.setAttribute('hidden', '');

  toggle.textContent = 'Lägg till';
  toggle.setAttribute('aria-expanded', 'false');

}

      return;
    }



    /* =========================================
       VÄLJ STORLEK
    ========================================= */

    const sizeButton = event.target.closest('.mf-upsell-size');

    if (sizeButton) {

      event.preventDefault();
      event.stopPropagation();

      /*
       * Gör ingenting om varianten är slutsåld
       */
      if (
        sizeButton.classList.contains('is-disabled') ||
        sizeButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      const panel = sizeButton.closest('.mf-upsell-inline');
      if (!panel) return;


      /*
       * Avmarkera tidigare vald storlek
       */
      panel.querySelectorAll('.mf-upsell-size').forEach(function (item) {

        item.classList.remove('is-selected');
        item.classList.remove('selected');

        item.setAttribute('aria-pressed', 'false');

      });


      /*
       * Markera vald storlek.
       *
       * "selected" används av temats CSS.
       * "is-selected" behåller vår egen hook.
       */
      sizeButton.classList.add('is-selected');
      sizeButton.classList.add('selected');

      sizeButton.setAttribute('aria-pressed', 'true');


      /*
       * Spara vald variant
       */
      panel.dataset.selectedVariant = sizeButton.dataset.variantId;

      updateUpsellPrice(panel, sizeButton);



      /*
       * Aktivera Lägg till-knappen
       */
      const confirm = panel.querySelector('.mf-upsell-confirm');

      if (confirm) {
        confirm.disabled = false;
      }

      return;
    }



    /* =========================================
       LÄGG TILL VALD VARIANT
    ========================================= */

    const confirm = event.target.closest('.mf-upsell-confirm');

    if (confirm) {

      event.preventDefault();
      event.stopPropagation();

      if (confirm.disabled) return;

      const panel = confirm.closest('.mf-upsell-inline');
      if (!panel) return;

      const variantId = panel.dataset.selectedVariant;

      if (!variantId) return;


      /*
       * Hitta temats AJAX-add-to-cart-hook
       * för exakt den variant kunden valt.
       */
      const nativeAdd = panel.querySelector(
        '.mf-upsell-native-add[data-vrid="' + variantId + '"]'
      );

      if (!nativeAdd) return;


      /*
       * Visa loading-state
       */
      confirm.disabled = true;
      confirm.textContent = 'Lägger till…';


      /*
       * Använd temats befintliga AJAX-cart.
       */
      nativeAdd.click();


      /*
       * Safety reset om temat av någon anledning
       * inte renderar om cart drawern.
       */
      setTimeout(function () {

        if (document.body.contains(confirm)) {

          confirm.disabled = false;
          confirm.textContent = 'Lägg till i varukorgen';

        }

      }, 4000);

    }

  });



  /*
   * Tangentbord:
   * Enter eller Space väljer storlek.
   */
  document.addEventListener('keydown', function (event) {

    const sizeButton = event.target.closest('.mf-upsell-size');

    if (!sizeButton) return;

    if (
      event.key !== 'Enter' &&
      event.key !== ' '
    ) {
      return;
    }

    event.preventDefault();

    sizeButton.click();

  });

})();